import {
  Component,
  OnInit,
} from '@angular/core';
import {MenuItem} from "primeng/api";
import {AuthService} from "../../services/auth.service";
import {KeycloakService} from "keycloak-angular";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  items: MenuItem[] = [];
  userName: string = "John Doe";
  constructor(
    public authService: AuthService,
    private keycloakService: KeycloakService
    ) {}
  ngOnInit(): void {
    this.items = [
      {
        label: 'Logout',
        command: this.onClick,
      },
    ]
  }

  onClick = (event: { item: MenuItem; originalEvent: Event }) => {
    this.keycloakService.logout();

  }
}
